import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { getInfoPages, getSite } from '../content/index.js';
import { scrollToUniversities } from '../utils/scroll.js';
import BrandLogo from './BrandLogo.jsx';

export default function Footer({ onProgramNavigate }) {
  const site = getSite();
  const companyLinks = getInfoPages();
  const navigate = useNavigate();

  function goPrograms(item) {
    if (onProgramNavigate) {
      onProgramNavigate(item);
      return;
    }
    const params = new URLSearchParams();
    if (item.search) params.set('search', item.search);
    if (item.level) params.set('level', item.level);
    navigate({ pathname: '/', search: params.toString(), hash: 'universities' });
  }

  function goAllUniversities(event) {
    event.preventDefault();
    if (window.location.pathname === '/') {
      scrollToUniversities();
      return;
    }
    navigate({ pathname: '/', hash: 'universities' });
  }

  return (
    <footer className="site-footer">
      <div className="container footer-grid">
        <div className="footer-brand">
          <Link to="/" className="logo logo-link footer-logo">
            <BrandLogo brand={site.brand} variant="footer" />
          </Link>
          <p>{site.tagline}</p>
          <a href="#counsel" className="cta-button footer-cta">
            {site.ctaPrimary}
          </a>
        </div>

        <div>
          <h3>Popular programs</h3>
          <ul className="footer-links">
            {(site.footerPrograms || []).map((item) => (
              <li key={item.label}>
                <button type="button" className="footer-link-btn" onClick={() => goPrograms(item)}>
                  {item.label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3>Explore</h3>
          <ul className="footer-links">
            <li>
              <a href="/#universities" onClick={goAllUniversities}>
                All universities
              </a>
            </li>
            <li>
              <a href="#counsel">{site.ctaCounsellor}</a>
            </li>
          </ul>
        </div>

        <div>
          <h3>Company</h3>
          <ul className="footer-links">
            {companyLinks.map((item) => (
              <li key={item.path}>
                <Link to={item.path}>{item.label}</Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="container footer-disclaimer">
        <p>{site.disclaimer}</p>
        <p className="footer-copy">© {new Date().getFullYear()} {site.brand}. All rights reserved.</p>
      </div>
    </footer>
  );
}
